import React from 'react';
import { Link } from 'react-router-dom';
import { cx } from './cx';

export interface TabItem { id: string; label: React.ReactNode; to?: string; badge?: React.ReactNode }

/** Underline tabs ("Review · Schedule & launch · Results"). Links when `to` is set. */
export const Tabs: React.FC<{ items: TabItem[]; value: string; onChange?: (id: string) => void; label: string; className?: string }> = ({
  items, value, onChange, label, className,
}) => (
  <nav aria-label={label} className={cx('flex gap-7 overflow-x-auto border-b border-line', className)}>
    {items.map(t => {
      const on = t.id === value;
      const cls = cx('inline-flex min-h-[44px] shrink-0 items-center gap-2 border-b-[3px] px-1 font-display text-[15px] font-bold no-underline',
        on ? 'border-brand text-ink' : 'border-transparent text-ink-3 hover:text-ink');
      return t.to
        ? <Link key={t.id} to={t.to} aria-current={on ? 'page' : undefined} className={cls}>{t.label}{t.badge}</Link>
        : <button key={t.id} type="button" aria-pressed={on} onClick={() => onChange?.(t.id)} className={cls}>{t.label}{t.badge}</button>;
    })}
  </nav>
);

/** Segmented choice ("All · Campaigns · Posts"); the selected one is navy. */
export const Segmented: React.FC<{ items: { id: string; label: React.ReactNode }[]; value: string; onChange: (id: string) => void; label: string; className?: string }> = ({
  items, value, onChange, label, className,
}) => (
  <div role="group" aria-label={label} className={cx('inline-flex w-max gap-1 rounded-btn bg-inset p-1', className)}>
    {items.map(it => (
      <button key={it.id} type="button" aria-pressed={it.id === value} onClick={() => onChange(it.id)}
        className={cx('min-h-[36px] rounded-[9px] px-3.5 text-sm font-semibold transition-colors',
          it.id === value ? 'bg-navy text-on-navy' : 'text-ink hover:bg-card')}>
        {it.label}
      </button>
    ))}
  </div>
);
